module.exports = __webpack_public_path__ + "img/rv.11377979.png";